export const paletteColors = {
    gold: '#99791C',
    white: '#FFFFFF',
    black: '#000000',
    gray: '#BBBBBB'
}